import React, { useEffect, useState } from 'react';
import '../styles/MyOrders.scss';
import View from '../components/View';
import Button from '../components/Button';
import MobileMenuBottom from '../components/MobileBottomMenu';
import Warning from '../assets/svgs/danger-sign.svg';
import { Link } from 'react-router-dom';
import OrderSummary from '../components/OrderSummary';
import MyAccountHeader from '../components/MyAccountHeader';
import AccountNav from '../components/AccountNav';
import { useSelector, useDispatch } from 'react-redux';
import { fetchOrders } from '../actions/Order';
import {
  getOrders,
  didFetchingOrdersFailed,
  isFetchingOrders,
} from '../selectors/Order';

const MyOrders = () => {
  const fetchingOrders = useSelector(isFetchingOrders);
  const orders = useSelector(getOrders);
  const [activeStatus, setActiveStatus] = useState(null);
  const fetchingFailed = useSelector(didFetchingOrdersFailed);
  console.log(fetchingOrders, fetchingFailed);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchOrders());
  }, [dispatch]);

  const statuses = [
    { label: 'ALL', value: null },
    { label: 'Processing', value:'Processing' },
    { label: 'Dispatched', value: 'Dispatched' },
    { label: 'Out for Delivery', value: 'Out for Delivery' },
    { label: 'Delivered', value: 'Delivered' },
  ];

  const onFilter = (status: any) => {
    console.log(status);
    setActiveStatus(status.value);
  };

  const ordersOrgAll = orders?.filter(o => activeStatus ? o.order_status === activeStatus : true);

  const ordersOrg = {};
  ordersOrgAll.map(o => {
    // @ts-ignore
    if (!ordersOrg[o.order_number]) {
      // @ts-ignore
      ordersOrg[o.order_number] = [];
    }
    // @ts-ignore
    ordersOrg[o.order_number].push(o);
  } );


  return (
        <View>
            <div className="grey-container">
                <div className="container myaccount">
                    <MyAccountHeader/>
                    <div className="row myaccount__content">
                        <div className="col-lg-3 myaccount__content__nav">
                            <AccountNav/>
                        </div>
                        <div className="col-lg-9 myaccount__content__body">
                            <div className="row myaccount__content__body__top">
                              <div className="myaccount__content__body__top__left">
                                <div className="myaccount__content__body__top__left__status">
                                    {statuses.map((s, i) =>
                                        <div onClick={() => onFilter(s)} key={i} className={`cursor-pointer myaccount__content__body__top__left__status__active ${s.value === activeStatus && 'active'}`}>
                                            <p> {i > 0 && ' | '} {s.label}</p>
                                        </div>,
                                    )}
                                </div>
                              </div>
                            </div>
                            <div className="row">
                                <div className="myaccount__content__body__popup">
                                    <div className="myaccount__content__body__popup__warning">
                                        <img src={Warning} alt="warning-sign"/>
                                    </div>
                                    <div className="myaccount__content__body__popup__text">
                                        <p>
                                            If you wish to cancel or amend an order please{' '}
                                            <Link to="/" className="text-orange">
                                                contact customer services.
                                            </Link>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="myaccount__content__body__count">
                                    <div className="myaccount__content__body__count__left">
                                        <p>Total Orders: {ordersOrgAll?.length} {activeStatus !== null ? `(${activeStatus})` : ''}</p>
                                    </div>
                                    <div className="myaccount__content__body__count__right">
                                        {/*<p>Displaying: Active Orders (14)</p>*/}
                                    </div>
                                </div>
                                {Object.keys(ordersOrg)?.sort((a, b) => parseInt(b) - parseInt(a)).map((p) => (
                                    <OrderSummary key={p}
                                        // @ts-ignore
                                                  orderLines={ordersOrg[p]}
                                                  orderNumber={p}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="contact-bottom">
                <div className="contact-bottom__title">
                    <h3>Can&apos;t find what you&apos;re looking for?</h3>
                </div>
                <div className="contact-bottom__desc">
                    <p>
                        Our support team would be happy to help, simply call or email us.
                    </p>
                </div>
                <div className="contact-bottom__cta">
                    <div className="contact-bottom__cta__left">
                        <Button text="Call Us"/>
                    </div>
                    <div className="contact-bottom__cta__left">
                        <Button text="Email Us"/>
                    </div>
                </div>
            </div>
            <MobileMenuBottom/>
        </View>
  );
};

export default MyOrders;
